module.exports = __webpack_public_path__ + "img/icon-only.351b8eaa.png";